module.exports = __webpack_public_path__ + "img/model.d8da17e4.svg";